// extracted by mini-css-extract-plugin
export var columnList = "_aj-0";